export default __webpack_public_path__ + "static/media/cancel.e806b475.svg";